import type UserInterface from '@/types/User'
import BaseObject from '@/objects/BaseObject'

const defaults: UserInterface = {
  id: null,
  tenant_group_id: undefined,
  name: '',
  email: '',
  active: false,
  user_created_send: false,
  login_app_allowed: false,
  login_software_allowed: false,
  settings: null,

  profile_picture: {
    big: null,
    filename: null,
    mime: null,
    small: null
  },

  // attributes
  two_factor_enabled: false,
  is_admin: false,
  is_super_admin: false,

  // attributes (frontend)
  checked: false,

  // relations
  roles: [],
}

export default class User extends BaseObject {
  declare options: UserInterface

  constructor (options: Partial<UserInterface> = {}) {
    super({ ...defaults, ...options })
  }

  public values (): UserInterface {
    return super.values()
  }
}

